import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import FinancialServicesOverview from "./sections/FinancialServicesOverview";
import CanalLivingContent from "./sections/CanalLivingContent";
import ChutVrbovceACenik from "./sections/ChutVrbovceACenik";
import DeepRelaxation from "./sections/DeepRelaxation";
import SiteFooter from "@/reusable_sections/Footer";
import AventuraLivingPatternsContent from "./sections/AventuraLivingPatternsContent";
import Mirroredtreatmentshowcase from "./sections/Mirroredtreatmentshowcase";
export default function ServicesPage() {
  return <div>
      <Header />
      <FinancialServicesOverview />
      <CanalLivingContent />
      <DeepRelaxation />
      <Mirroredtreatmentshowcase />
      <AventuraLivingPatternsContent />
      <ChutVrbovceACenik />
      <SiteFooter />
    </div>;
}